export enum ModerationSubjectType {
  /** резюме или вакансия */
  CatalogItem = 1,
  /** отзыв */
  Review = 2,
  /** Ответ на отзыв */
  ReviewAnswer = 3,
  /** Профиль клиента */
  Client = 4,
  /** Загруженный документ */
  ClientDocument = 5,
  /** Аудио-видео обращение в резюме (вакансии) */
  CatalogItemMedia = 6,
}
